import React from 'react';
import './LoveHoro.scss';
import { useState } from 'react';
import Footer from '../components/Footer/Footer';
import InnerNav from '../components/InnerNav/InnerNav';
import Zodiac from '../components/ZodiacSign/Zodiac';
import axios from 'axios';
import cityData from '../city.json'; // adjust path


const LoveHoro = () => {
const [citySuggestions, setCitySuggestions] = useState([]);

const handleCityChange = (value) => {
  handleChange('city', value);

  if (value.trim() === "") {
    setCitySuggestions([]);
    return;
  }

  // match cities starting with the typed value
  const filtered = cityData.filter(c =>
    c.city.toLowerCase().startsWith(value.toLowerCase())
  );

  setCitySuggestions(filtered.slice(0, 4)); // only top 4
};

const handleSelectCity = (cityName) => {
  handleChange('city', cityName);
  setCitySuggestions([]); // close suggestions
};

  const [formData, setFormData] = useState({
    name: '',
    gender: '',
    birthMonth: 'July',
    birthDay: '7',
    birthYear: '2025',
    birthHour: '4',
    birthMinute: '24',
    birthSecond: '46',
    birthMeridiem: 'PM',
    city: ''
  });

  const [showPopup, setShowPopup] = useState(false);
  const [resultData, setResultData] = useState(null);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };




const convertTo24Hour = (hour, meridiem) => {
  const h = Number(hour);
  if (meridiem === 'AM') return h === 12 ? 0 : h;
  return h === 12 ? 12 : h + 12;
};


const handleSubmit = async (e) => {
  e.preventDefault();

  //  Transform formData into the format my API expects:
 
   const name =formData.name
   //const gender = formData.gender
    const city =formData.city
   const day = Number(formData.birthDay)
    const month = new Date(`${formData.birthMonth} 1, 2000`).getMonth() + 1
    const year= Number(formData.birthYear)
   const hour = convertTo24Hour(formData.birthHour, formData.birthMeridiem)
    const minute = Number(formData.birthMinute)
  

 
    

  try {
   
    const response = await axios.get(`https://core-c343.onrender.com/api/predict-love?name=${name}&location=${city}&year=${year}&month=${month}&day=${day}&hour=${hour}&minute=${minute}`);
    setResultData(response.data);
    setShowPopup(true);
  } catch (error) {
    console.error("API error:", error);
    alert("Something went wrong.");
  }
};


  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
        <div className="lovehoro-container">
        <InnerNav/>
        <div className="lovehoro-content">
            <Zodiac/>
    <div className="horoscope-form-container">
      <div className="form-title">Birth Details for Love Horoscope</div>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>👤 Name</label>
          <input
            type="text"
            value={formData.name}
            placeholder="Enter Name"
            onChange={(e) => handleChange('name', e.target.value)}
            required
          />
        </div>

        <div className="form-group gender-group">
          <label>Gender</label>
          <div className="gender-options">
            <button
              type="button"
              className={formData.gender === 'Male' ? 'selected' : ''}
              onClick={() => handleChange('gender', 'Male')}
              required
            >
              ♂ Male
            </button>
            <button
              type="button"
              className={formData.gender === 'Female' ? 'selected' : ''}
              onClick={() => handleChange('gender', 'Female')}
              required
            >
              ♀ Female
            </button>
          </div>
        </div>


        <div className="form-group">
          <label>📅 Birth Date</label>
          <div className="select-row">
            <select value={formData.birthMonth} onChange={(e) => handleChange('birthMonth', e.target.value)}>
              {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(month => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>
            <select value={formData.birthDay} onChange={(e) => handleChange('birthDay', e.target.value)}>
              {Array.from({ length: 31 }, (_, i) => (
                <option key={i+1} value={i+1}>{i+1}</option>
              ))}
            </select>
            <select value={formData.birthYear} onChange={(e) => handleChange('birthYear', e.target.value)}>
              {Array.from({ length: 201 }, (_, i) => {
                const year = 2025 - 100 + i;
                return <option key={year} value={year}>{year}</option>;
              })}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>⏰ Birth Time</label>
          <div className="select-row">
            <select value={formData.birthHour} onChange={(e) => handleChange('birthHour', e.target.value)}>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i+1} value={i+1}>{i+1}</option>
              ))}
            </select>
            <select value={formData.birthMinute} onChange={(e) => handleChange('birthMinute', e.target.value)}>
              {Array.from({ length: 60 }, (_, i) => (
                <option key={i} value={i}>{i}</option>
              ))}
            </select>
            <select value={formData.birthSecond} onChange={(e) => handleChange('birthSecond', e.target.value)}>
              {Array.from({ length: 60 }, (_, i) => (
                <option key={i} value={i}>{i}</option>
              ))}
            </select>
            <select value={formData.birthMeridiem} onChange={(e) => handleChange('birthMeridiem', e.target.value)}>
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>📍 Birth City</label>
          <input
            type="text"
            value={formData.city}
            placeholder="Enter City"
            onChange={(e) => handleCityChange(e.target.value)}
            required
          />
            {citySuggestions.length > 0 && (
              <ul className="suggestion-list">
                {citySuggestions.map((c, idx) => (
                  <li
                    key={idx}
                    onClick={() => handleSelectCity(c.city)}
                  >
                    {c.city}, {c.state}, {c.country}
                  </li>
                ))}
              </ul>
            )}
        </div>

       

        <div className="form-actions">
          <button type="button" className="clear-btn" onClick={() => setFormData({ ...formData, name: '', city: '' })}>CLEAR</button>
          <button type="submit" className="submit-btn">SUBMIT</button>
        </div>
      </form>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Love Horoscope Result</h2>
             {resultData?.sections &&
              Object.entries(resultData.sections).map(([subTitle, content]) => (
                <div key={subTitle} className="lhh-card">
                  <h3>{subTitle}</h3>
                  <p>{content}</p>
                </div>
              ))}
            <button className="close-btn" onClick={handleClosePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
    </div>
    <Footer/>
    </div>
  );
};

export default LoveHoro;
